'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function makeChecker(pubkeyTypes) {
  return checkPubkey;

  function checkPubkey(keyVal) {
    var pubkey;

    if (pubkeyTypes.includes(keyVal.key[0])) {
      pubkey = keyVal.key.slice(1);

      if (!(pubkey.length === 33 || pubkey.length === 65) || ![2, 3, 4].includes(pubkey[0])) {
        throw new Error('Format Error: invalid pubkey in key 0x' + keyVal.key.toString('hex'));
      }
    }

    return pubkey;
  }
}

exports.makeChecker = makeChecker;